
import { BlogPostWireframe } from "./BlogPostWireframe";

export const BlogPostLoadingState = () => {
  return <BlogPostWireframe />;
};
